import Vue from 'vue'
// use vue-i18n
import lodash from 'lodash'
import VueI18n from 'vue-i18n'
import zhLocale from './locale/zh-CN/index'
import enLocale from './locale/en/index'

Vue.use(VueI18n)
// 设置版本语言

// 时代光华要求 所有 “项目”字样改为“微课”
let tbcLocale = lodash.cloneDeep(zhLocale)
tbcLocale['common']['project'] = '微课'

// the global instance for i18n
let i18nInstance = new VueI18n({
  locale: process.env.LOCALE,
  fallbackLocale: 'zh-cn',
  silentTranslationWarn: true,
  messages: {
    en: enLocale,
    'zh-cn': zhLocale,
    'tbc': tbcLocale
  }
})

export default i18nInstance



// WEBPACK FOOTER //
// ./src/i18n/index.js